import { render, staticRenderFns } from "./MyWr1Booking.vue?vue&type=template&id=c70f9a36"
import script from "./MyWr1Booking.vue?vue&type=script&lang=js"
export * from "./MyWr1Booking.vue?vue&type=script&lang=js"
import style0 from "./MyWr1Booking.vue?vue&type=style&index=0&id=c70f9a36&prod&lang=css"
import style1 from "./MyWr1Booking.vue?vue&type=style&index=1&id=c70f9a36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports